// ============================================================
// Silk Route — CRO Revamp shared behaviors (sr2)
// Lightbox · accordions · skin stages · qty · plan selector ·
// sticky ATC · reliable video autoplay
// ============================================================

(function () {
  'use strict';

  // ── Artwork lightbox ──
  // Registry is rendered by snippets/sr2-lightbox.liquid as JSON.

  var lightbox, lbImg, lbTitle, lbFacts, lbBlurb, artRegistry = {};

  function initLightbox() {
    lightbox = document.getElementById('sr2-lightbox');
    if (!lightbox) return;
    var dataEl = document.getElementById('sr2-artwork-data');
    if (dataEl) {
      try { artRegistry = JSON.parse(dataEl.textContent); } catch (e) { artRegistry = {}; }
    }
    lbImg = lightbox.querySelector('.sr2-lightbox__img');
    lbTitle = lightbox.querySelector('.sr2-lightbox__title');
    lbFacts = lightbox.querySelector('.sr2-lightbox__facts');
    lbBlurb = lightbox.querySelector('.sr2-lightbox__blurb');

    lightbox.querySelector('.sr2-lightbox__backdrop').addEventListener('click', closeArt);
    lightbox.querySelector('.sr2-lightbox__close').addEventListener('click', closeArt);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeArt();
    });
  }

  function openArt(key) {
    var art = artRegistry[key];
    if (!art || !lightbox) return;
    lbImg.src = art.img;
    lbImg.alt = art.title;
    lbTitle.textContent = art.title;
    lbFacts.textContent = [art.place, art.date, art.museum, art.lic].filter(Boolean).join(' · ');
    lbBlurb.textContent = art.blurb || '';
    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeArt() {
    if (!lightbox || !lightbox.classList.contains('is-open')) return;
    lightbox.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // Any element carrying data-sr2-art opens the lightbox: the credit chips
  // (native buttons) and the credited artwork regions themselves (role=button
  // divs on the Our Story art bands).
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-sr2-art]');
    if (!trigger) return;
    e.preventDefault();
    openArt(trigger.getAttribute('data-sr2-art'));
  });

  // Keyboard parity for the non-native-button triggers (role=button divs).
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var trigger = e.target.closest('[data-sr2-art]');
    if (!trigger || trigger.tagName === 'BUTTON') return;
    e.preventDefault();
    openArt(trigger.getAttribute('data-sr2-art'));
  });

  // ── Accordions (single item toggle) ──

  document.addEventListener('click', function (e) {
    var head = e.target.closest('.sr2-acc__head');
    if (!head) return;
    var acc = head.closest('.sr2-acc');
    var open = acc.classList.toggle('is-open');
    var icon = acc.querySelector('.sr2-acc__icon');
    if (icon) icon.textContent = open ? '−' : '+';
    head.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  // ── Numbered skin-stages explainer ──
  // Buttons: [data-sr2-stage="i"] inside [data-sr2-stages]
  // Caption card children: [data-sr2-stage-panel="i"]

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sr2-stage]');
    if (!btn) return;
    var root = btn.closest('[data-sr2-stages]');
    if (!root) return;
    var idx = btn.getAttribute('data-sr2-stage');
    root.querySelectorAll('[data-sr2-stage]').forEach(function (b) {
      b.classList.toggle('is-active', b === btn);
    });
    root.querySelectorAll('[data-sr2-stage-panel]').forEach(function (p) {
      p.style.display = p.getAttribute('data-sr2-stage-panel') === idx ? '' : 'none';
    });
  });

  // ── Qty stepper ──

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sr2-qty]');
    if (!btn) return;
    var wrap = btn.closest('.sr2-qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    input.value = btn.getAttribute('data-sr2-qty') === 'inc' ? v + 1 : Math.max(1, v - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // ── Plan selector ──
  // Root: [data-sr2-plans]. Cards: label.sr2-plan with input[name=sr2-plan]
  // carrying data-price (paise), data-compare (paise), data-selling-plan (id or "").
  // Price outputs: [data-sr2-price-out], [data-sr2-plan-label-out] anywhere on page.
  // Hidden selling plan input: [data-sr2-selling-plan-input]

  function fmtMoney(paise) {
    return '₹' + (paise / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }

  function applyPlan(input) {
    var root = input.closest('[data-sr2-plans]') || document;
    root.querySelectorAll('.sr2-plan').forEach(function (card) {
      card.classList.toggle('is-selected', card.contains(input));
    });
    var price = parseInt(input.getAttribute('data-price'), 10);
    var label = input.getAttribute('data-plan-label') || '';
    var sellingPlan = input.getAttribute('data-selling-plan') || '';

    document.querySelectorAll('[data-sr2-price-out]').forEach(function (el) {
      if (!isNaN(price)) el.textContent = fmtMoney(price);
    });
    document.querySelectorAll('[data-sr2-plan-label-out]').forEach(function (el) {
      el.textContent = label;
    });
    document.querySelectorAll('[data-sr2-selling-plan-input]').forEach(function (el) {
      el.value = sellingPlan;
      el.disabled = sellingPlan === '';
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-sr2-plans] input[type="radio"]')) applyPlan(e.target);
  });

  // ── Add to cart ──
  // Razorpay Magic Checkout's script swallows form submit events site-wide,
  // so (like main-product.liquid) we intercept the button CLICK, prevent the
  // submit from ever firing, and do the AJAX add ourselves.

  function sr2AddToCart(form) {
    var btn = form.querySelector('[type="submit"]');
    var orig = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: new URLSearchParams(new FormData(form))
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        if (typeof fbq === 'function') fbq('track', 'AddToCart', { currency: 'INR' });
        if (typeof gtag === 'function') gtag('event', 'add_to_cart', { currency: 'INR' });
        if (window.SRTracking) window.SRTracking.attachToCart();
        if (btn) btn.textContent = 'Added ✓';
        if (window.SilkCart) window.SilkCart.open();
        setTimeout(function () {
          if (btn) { btn.textContent = orig; btn.disabled = false; }
        }, 1800);
      })
      .catch(function () {
        if (btn) { btn.textContent = orig; btn.disabled = false; }
        // Last resort: native submit so the customer can still buy
        form.submit();
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.sr2 form[action*="/cart/add"] [type="submit"], body.sr2 form[action*="/cart/add"] [type="submit"]');
    if (!btn) return;
    var form = btn.closest('form');
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    sr2AddToCart(form);
  }, true);

  // Fallback for keyboard Enter / programmatic submits on sr2 forms
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form || !form.closest('body.sr2')) return;
    if (form.hasAttribute('data-section-handler')) return;
    e.preventDefault();
    e.stopPropagation();
    sr2AddToCart(form);
  }, true);

  // ── Sticky add-to-cart bar ──
  // Shows once the buy box [data-sr2-buybox] scrolls out of view.

  function initStickyAtc() {
    var bar = document.querySelector('.sr2-sticky-atc');
    var buybox = document.querySelector('[data-sr2-buybox]');
    if (!bar || !buybox || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(buybox);

    var stickyBtn = bar.querySelector('[data-sr2-sticky-atc-btn]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var form = document.querySelector('form[data-sr2-product-form]');
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }
  }

  // ── Reliable muted autoplay for hero + reels ──
  // Videos play only while in the viewport: saves mobile data, keeps
  // scrolling smooth, and hidden videos (e.g. hero video on phones)
  // never download at all.

  function tryPlay(v) {
    v.muted = true;
    v.setAttribute('muted', '');
    v.loop = true;
    v.playsInline = true;
    var p = v.play && v.play();
    if (p && p.catch) p.catch(function () { /* poster remains */ });
  }

  function initAutoplay() {
    var vids = document.querySelectorAll('video[data-sr2-autoplay]');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) {
      vids.forEach(tryPlay);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          tryPlay(v);
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { rootMargin: '80px 0px' });
    vids.forEach(function (v) { io.observe(v); });
  }

  // ── Mobile nav burger ──

  document.addEventListener('click', function (e) {
    var burger = e.target.closest('.sr2-nav__burger');
    if (burger) {
      var nav = burger.closest('.sr2-nav');
      var open = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    // Close the menu after tapping a link
    var link = e.target.closest('.sr2-nav__links a');
    if (link) {
      var openNav = link.closest('.sr2-nav.is-open');
      if (openNav) openNav.classList.remove('is-open');
    }
  });

  // ── Scroll reveal (standalone fallback) ──

  function initReveal() {
    var els = document.querySelectorAll('.sr2 [data-reveal], body.sr2 [data-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  // ── Landing header: transparent over the hero, solid past it ──
  // Only runs on the landing page (the wrap carries --landing there).
  // The header stays see-through while any part of the hero sits behind
  // it, then gains its background the moment the hero scrolls up past
  // the fixed header — i.e. as the next section arrives.

  function initHeaderScroll() {
    var wrap = document.querySelector('.sr2-headwrap--landing');
    if (!wrap) return;
    var hero = document.querySelector('.sr2-hero');

    function setSolid(on) { wrap.classList.toggle('is-scrolled', on); }

    if (hero && 'IntersectionObserver' in window) {
      var headerH = Math.round(wrap.offsetHeight) || 0;
      var io = new IntersectionObserver(function (entries) {
        setSolid(!entries[0].isIntersecting);
      }, { rootMargin: '-' + headerH + 'px 0px 0px 0px', threshold: 0 });
      io.observe(hero);
      // IO callbacks can lag a beat behind fast momentum scrolls (iOS
      // Safari), leaving the transparent header's white text sitting on
      // page content. A cheap per-scroll check keeps the state honest.
      var syncSolid = function () {
        setSolid(hero.getBoundingClientRect().bottom <= (wrap.offsetHeight || 0));
      };
      window.addEventListener('scroll', syncSolid, { passive: true });
      syncSolid();
    } else {
      var onScroll = function () { setSolid((window.pageYOffset || 0) > 60); };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }

  // ── Announcement bar: rotate messages one at a time ──

  function initAnnounceRotator() {
    document.querySelectorAll('[data-sr2-announce]').forEach(function (rot) {
      var msgs = rot.querySelectorAll('.sr2-announce__msg');
      if (msgs.length < 2) return;
      var i = 0;
      setInterval(function () {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, 4200);
    });
  }

  // ── Boot ──

  function boot() {
    initLightbox();
    initStickyAtc();
    initAutoplay();
    initReveal();
    initHeaderScroll();
    initAnnounceRotator();
    var checked = document.querySelector('[data-sr2-plans] input[type="radio"]:checked');
    if (checked) applyPlan(checked);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.SR2 = { openArt: openArt, closeArt: closeArt };
})();
